import { DASHBOARD_LABELS } from 'src/common/labels/dashboard.labels';

export const HEADER = {
	title: DASHBOARD_LABELS.WEB_DASHBOARD_TITLE,
	showLastUpdated: true
};
